import { render, staticRenderFns } from "./WatermarkContainer.vue?vue&type=template&id=3d81696b&scoped=true&"
import script from "./WatermarkContainer.vue?vue&type=script&lang=ts&"
export * from "./WatermarkContainer.vue?vue&type=script&lang=ts&"
import style0 from "./WatermarkContainer.vue?vue&type=style&index=0&id=3d81696b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d81696b",
  null
  
)

export default component.exports